<template>
  <v-container>
    <v-card>
      <v-card-title>Relación de Docentes </v-card-title>
      <v-card-subtitle>
        <download-csv
          :data="docentesCsv"
          class="btn btn-default"
          style="cursor: pointer"
          v-if="docentesCsv.length > 0"
          name="docentes.csv"
          >CSV
          <v-icon>mdi-file-delimited-outline</v-icon>
        </download-csv></v-card-subtitle
      >
      <v-card-text style="height: 15px; position: relative; top: -30px">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              absolute
              top
              right
              fab
              v-bind="attrs"
              v-on="on"
              @click="nuevoDocente"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Agregar Docente</span>
        </v-tooltip>
      </v-card-text>
    </v-card>

    <v-divider></v-divider>

    <v-card>
      <template>
        <v-tabs show-arrows fixed-tabs v-model="tabSelected">
          <v-tab @click="getDocentes('all')"> Activos </v-tab>
          <v-tab @click="getDocentes('tv')"> Del Turno Vespertino </v-tab>
          <v-tab @click="getDocentes('mx')"> En ambos turnos </v-tab>
          <v-tab @click="getDocentes('tm')"> Del Turno Matutino </v-tab>
          <v-tab @click="getDocentes('inactive')"> No activos </v-tab>
        </v-tabs>
      </template>

      <v-divider></v-divider>

      <v-card-text v-if="dataFound">
        <v-list subheader>
          <v-list-item
            link
            v-for="(docente, index) in docentes"
            :key="docente.id"
            @click.stop="muestraDocente(index)"
          >
            <v-list-item-icon class="mt-3 mb-0">{{
              parseInt(index) + 1
            }}</v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ docente.apellidos + ", " + docente.nombre }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ docente.email }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        <p>Presione el botón para cargar los datos</p>
        <p class="text-center">
          <v-btn @click="getDocentes('all')">Cargar datos</v-btn>
        </p></v-card-text
      >
    </v-card>

    <Docente
      :open="showDocente"
      :docente="docente"
      @save="actualizaDocente('patch')"
      @exit="ocultaDocente"
      @delete="actualizaDocente('delete')"
    />
  </v-container>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import api from "@/api";
import fn from "@/fn";
import Docente from "@/components/Docente";

export default {
  name: "Docentes",

  components: { Docente },

  data: () => ({
    dataFound: false,
    docentes: null,
    showDocente: false,
    tabSelected: 0,
    newDocente: false,
    docente: {
      id: "",
      nombre: "",
      apellidos: "",
      rfc: "",
      activo: "0",
      sexo: "",
      turno: "",
      grado_maximo_estudios: "",
      estudio: "",
      egreso_de: "",
      ingreso_sep: "",
      ingreso_subsistema: "",
      plaza_horas: "",
      maximo_horas_frente_a_grupo: "",
      email: "",
      celular: "",
    },
  }),

  computed: {
    docentesCsv() {
      if (this.docentes) {
        let arr = [];
        let items = this.docentes;
        let result = Object.keys(items).map(function (key) {
          arr.push({ nombre: items[key].apellidos + " " + items[key].nombre });
        });
        return arr;
      }
      return [];
    },
  },

  methods: {
    ...mapMutations(["setAlert", "hideAlert"]),

    async actualizaDocente(action) {
      let data = {
        table: "docentes",
        scope: "ind",
        data: this.docente,
      };
      if (this.newDocente) {
        data = {
          ...data,
          action: "insert",
        };
      } else {
        if (this.docente.id + "." != ".") {
          data = {
            ...data,
            action: action,
          };
        }
      }
      if (this.newDocente || this.docente.id + "." != ".") {
        try {
          const response = await api.send(data);
          switch (this.tabSelected) {
            case 0:
              this.getDocentes("all");
              break;
            case 1:
              this.getDocentes("tv");
              break;
            case 2:
              this.getDocentes("mx");
              break;
            case 3:
              this.getDocentes("tm");
              break;
            case 4:
              this.getDocentes("inactive");
              break;
          }
        } catch (error) {
          console.log(error);
        }
        this.showDocente = false;
        this.newDocente = false;
        this.docente = JSON.parse(
          '{"id":"","nombre":"","apellidos":"","rfc":"","activo":"0","sexo":"","turno":"","grado_maximo_estudios":"","estudio":"","egreso_de":"","ingreso_sep":"","ingreso_subsistema":"","plaza_horas":"","maximo_horas_frente_a_grupo":"","email":"","celular":""}'
        );
      }
    },

    async getDocentes(scope) {
      let data = {
        table: "docentes",
        action: "get",
        scope: scope,
        sort: "apellidos, nombre",
      };
      try {
        const response = await api.send(data);
        if (response.status == 200) {
          if (response.data == null) {
            this.dataFound = false;
            this.setAlert({
              text:
                "No se encontró registro de docentes con los criterios especificados",
              type: "error",
            });
          } else {
            this.hideAlert();
            this.dataFound = true;
            this.docentes = response.data;
          }
        } else {
          this.dataFound = false;
          this.setAlert({
            text: "No se ha podido acceder la información solicitada",
            type: "error",
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    muestraDocente(idx) {
      this.showDocente = true;
      this.docente = JSON.parse(JSON.stringify(this.docentes[parseInt(idx)]));
    },

    nuevoDocente() {
      this.newDocente = true;
      this.showDocente = true;
      this.docente = JSON.parse(
        '{"id":"","nombre":"","apellidos":"","rfc":"","activo":"0","sexo":"","turno":"","grado_maximo_estudios":"","estudio":"","egreso_de":"","ingreso_sep":"","ingreso_subsistema":"","plaza_horas":"","maximo_horas_frente_a_grupo":"","email":"","celular":""}'
      );
    },

    ocultaDocente() {
      this.showDocente = false;
      this.newDocente = false;
      this.docente = JSON.parse(
        '{"id":"","nombre":"","apellidos":"","rfc":"","activo":"0","sexo":"","turno":"","grado_maximo_estudios":"","estudio":"","egreso_de":"","ingreso_sep":"","ingreso_subsistema":"","plaza_horas":"","maximo_horas_frente_a_grupo":"","email":"","celular":""}'
      );
    },

    slugify(text) {
      return fn.slugify(text);
    },
  },

  mounted() {
    // this.hidePageBar();
    // La segunda opcion es sin los map's
    // this.$store.commit("hidePageBar");
    this.$store.commit("setPageTitle", "Docentes");
    this.getDocentes("all");
  },
};
</script>